<script setup lang="ts">
type StyleProperty = 'borderRadius' | 'width' | 'height'

type Property = string | number

type Props = {
  width?: Property
  height?: Property
  radius?: Property
}

const props = defineProps<Props>()

const componentStyles = computed(() => {
  const styles: Partial<Record<StyleProperty, string>> = {}

  if (props.radius) styles.borderRadius = getUnitProperty(props.radius)

  if (props.width) styles.width = getUnitProperty(props.width)

  if (props.height) styles.height = getUnitProperty(props.height)

  return styles
})

const getUnitProperty = (property: Property) => {
  if (typeof property === 'number') return `${property}px`

  if (/(px|%)$/.test(property)) return property

  return `${property}px`
}
</script>

<template>
  <div class="app-skeleton" :style="componentStyles" />
</template>

<style scoped lang="scss">
.app-skeleton {
  flex-shrink: 0;
  background: linear-gradient(
    122.57deg,
    #f1f3f9 34.56%,
    #ffffff 51.72%,
    #f1f4f9 79.78%
  );
  background-size: 1200px 100%;
  animation: ui-skeleton 3s linear infinite forwards;
}

@keyframes ui-skeleton {
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
}
</style>
